import React, { Fragment } from "react";
import { useParams, Link } from "react-router-dom";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import ServicesDropdown from "./ServicesDropdown";
import servicesData from "./servicesData";
import { serviceGroups } from "./serviceGroupsData";
import { FaHandsHelping, FaArrowRight } from "react-icons/fa";
import UniformCard from "../../components/UniformCard/UniformCard";
import { Box, Typography } from "@mui/material";

const ClickHandler = () => {
  window.scrollTo(10, 0);
};

const formatSlug = (text) => {
  if (!text) return "";
  return text
    .replace(/&/g, "And")
    .replace(/-/g, " ")
    .replace(/[^a-zA-Z0-9 ]/g, "")
    .split(" ")
    .map((word, i) =>
      i === 0
        ? word.toLowerCase()
        : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    )
    .join("");
};

const ServiceGroupPage = () => {
  const { slug } = useParams();

  // Find the service group that matches the slug
  const groupData = serviceGroups.find((g) => g.slug === slug);

  if (!groupData) {
    return (
      <Fragment>
        <PageTitle pageTitle="Group Not Found" pagesub={"Services"} />
        <section className="section-padding text-center">
          <div className="container">
            <h2>Oops! Service group not found.</h2>
            <Link to="/services" className="theme-btn">
              Back to Services
            </Link>
          </div>
        </section>
        <Scrollbar />
      </Fragment>
    );
  }

  // Filter services belonging to this group
  const groupServices = servicesData.filter((s) =>
    groupData.filterCategories.includes(s.category)
  );

  return (
    <Fragment>
      <PageTitle pageTitle={groupData.title} />

      <section
        className="service-group-section section-padding"
        style={{ backgroundColor: "#f8f9fa" }}
      >
        <div className="container">
          <div className="row g-4">
            {/* Main Content */}
            <div className="col col-lg-9 col-12">
              {/* Hero Card */}
              <div
                className="service-hero-card"
                style={{
                  background: "var(--primary-color)",
                  borderRadius: "15px",
                  padding: "60px 45px",
                  marginBottom: "40px",
                  boxShadow: "0 20px 40px rgba(0,0,0,0.15)",
                  position: "relative",
                  overflow: "hidden",
                }}
              >
                <h1
                  style={{
                    color: "#fff",
                    fontSize: "2.8rem",
                    fontWeight: "800",
                    marginBottom: "25px",
                    position: "relative",
                    zIndex: 1,
                    lineHeight: "1.2",
                  }}
                >
                  {groupData.title}
                </h1>
                {groupData.intro && (
                  <p
                    style={{
                      color: "rgba(255,255,255,0.9)",
                      fontSize: "1.25rem",
                      lineHeight: "1.7",
                      marginBottom: 0,
                      position: "relative",
                      zIndex: 1,
                      maxWidth: "800px",
                    }}
                  >
                    {groupData.intro}
                  </p>
                )}
              </div>

              {/* Overview Section */}
              {groupData.description && (
                <div
                  style={{
                    background: "#fff",
                    borderRadius: "20px",
                    padding: "45px",
                    marginBottom: "50px",
                    boxShadow: "0 10px 30px rgba(0,0,0,0.05)",
                    borderLeft: "6px solid var(--primary-color)",
                  }}
                >
                  <h3
                    style={{
                      color: "var(--primary-color)",
                      fontSize: "1.8rem",
                      fontWeight: "700",
                      marginBottom: "25px",
                      display: "flex",
                      alignItems: "center",
                      gap: "15px",
                    }}
                  >
                    <span
                      style={{
                        width: "30px",
                        height: "4px",
                        background: "var(--primary-color)",
                        borderRadius: "2px",
                      }}
                    ></span>
                    Overview
                  </h3>
                  <div
                    style={{
                      color: "#4a5568",
                      fontSize: "1.15rem",
                      lineHeight: "1.8",
                    }}
                  >
                    {groupData.description.map((para, i) => {
                      const parts = para.split(": ");
                      if (parts.length > 1 && parts[0].length < 60) {
                        return (
                          <p
                            key={i}
                            style={{
                              marginBottom:
                                i === groupData.description.length - 1
                                  ? 0
                                  : "20px",
                            }}
                          >
                            <strong
                              style={{
                                color: "var(--primary-color)",
                                display: "block",
                                fontSize: "1.3rem",
                                marginBottom: "8px",
                              }}
                            >
                              {parts[0]}
                            </strong>
                            {parts[1]}
                          </p>
                        );
                      }
                      return (
                        <p
                          key={i}
                          style={{
                            marginBottom:
                              i === groupData.description.length - 1
                                ? 0
                                : "20px",
                          }}
                        >
                          {para}
                        </p>
                      );
                    })}
                  </div>
                </div>
              )}

              {/* Services Grid */}
              <div style={{ marginBottom: "60px" }}>
                <div style={{ textAlign: "center", marginBottom: "45px" }}>
                  <h2
                    style={{
                      color: "var(--primary-color)",
                      fontSize: "2.4rem",
                      fontWeight: "800",
                      marginBottom: "15px",
                      letterSpacing: "-0.5px",
                    }}
                  >
                    Our Core Services
                  </h2>
                  <div
                    style={{
                      width: "60px",
                      height: "5px",
                      background:
                        "linear-gradient(to right, var(--primary-color), #2a52be)",
                      margin: "0 auto",
                      borderRadius: "10px",
                    }}
                  ></div>
                </div>

                <div className="row g-4">
                  {groupServices.map((service) => (
                    <div className="col-12 col-md-6" key={service.Id}>
                      <Link
                        to={`/service-category/${formatSlug(service.sTitle)}`}
                        onClick={ClickHandler}
                        style={{ textDecoration: "none" }}
                      >
                        <UniformCard
                          image={service.image}
                          title={service.sTitle}
                          imageFit="contain"
                          aspectRatio="16/8"
                          imagePadding="5px"
                          centered={false}
                          sx={{
                            cursor: "pointer",
                            height: "100%",
                            display: "flex",
                            flexDirection: "column",
                            "& .card-image-hover": {
                              transition:
                                "transform 0.6s cubic-bezier(0.4, 0, 0.2, 1)",
                            },
                            "&:hover": {
                              transform: "translateY(-10px)",
                              borderColor: "var(--primary-color)",
                              boxShadow:
                                "0 20px 40px rgba(var(--primary-color-rgb), 0.15)",
                            },
                          }}
                        >
                          <Box sx={{ mt: "auto", pt: 1 }}>
                            <Typography
                              sx={{
                                color: "var(--primary-color)",
                                fontWeight: 600,
                                fontSize: "0.95rem",
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                              }}
                            >
                              Explore More
                              <FaArrowRight style={{ fontSize: "0.8rem" }} />
                            </Typography>
                          </Box>
                        </UniformCard>
                      </Link>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Sidebar */}
            <div className="col col-lg-3 col-12">
              <div style={{ position: "sticky", top: "100px" }}>
                <div
                  style={{
                    background: "#fff",
                    borderRadius: "20px",
                    padding: "30px",
                    marginBottom: "30px",
                    boxShadow: "0 10px 30px rgba(0,0,0,0.05)",
                    border: "1px solid rgba(0,0,0,0.05)",
                  }}
                >
                  <ServicesDropdown
                    ClickHandler={ClickHandler}
                    ServicesData={servicesData}
                  />
                </div>

                <div
                  style={{
                    background: "var(--primary-color)",
                    borderRadius: "15px",
                    padding: "40px 30px",
                    textAlign: "center",
                    boxShadow: "0 15px 35px rgba(0,0,0,0.15)",
                  }}
                >
                  <div
                    style={{
                      width: "60px",
                      height: "60px",
                      background: "rgba(255,255,255,0.1)",
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      margin: "0 auto 20px",
                    }}
                  >
                    <FaHandsHelping size={28} color="#fff" />
                  </div>
                  <h4
                    style={{
                      color: "#fff",
                      fontSize: "1.3rem",
                      marginBottom: "15px",
                    }}
                  >
                    Need Help?
                  </h4>
                  <p
                    style={{
                      color: "rgba(255,255,255,0.8)",
                      fontSize: "0.95rem",
                      marginBottom: "25px",
                    }}
                  >
                    Speak with our experts for professional guidance.
                  </p>
                  <Link
                    onClick={ClickHandler}
                    to="/contact"
                    style={{
                      display: "block",
                      background: "#fff",
                      color: "var(--primary-color)",
                      padding: "12px",
                      borderRadius: "50px",
                      fontWeight: "700",
                      textDecoration: "none",
                    }}
                  >
                    Contact Us
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Scrollbar />
    </Fragment>
  );
};

export default ServiceGroupPage;
